module.exports = __webpack_public_path__ + "static/media/totalHoursStreamed.0c9cf159.svg";